import { submitDeleteMessageFlow } from './submitDeleteMessageFlow'
import { submitDeleteLabelFlow } from './submitDeleteLabelFlow'
import { submitDeleteMessageFileFlow } from './submitDeleteMessageFileFlow'

export const submitDeleteFlows = [
  submitDeleteMessageFlow,
  submitDeleteLabelFlow,
  submitDeleteMessageFileFlow,
]
